import { type ApplicationType, InterfaceType } from '@unifyapps/defs/types/interface';
import type { Filter } from '@unifyapps/network/generated/models/filter';

// todo: reuse this from
// packages/carbon/src/components/TemplateComponent/utils/templateAggregationQuery.ts

export const isStandard = (value: boolean): Filter =>
  value
    ? { field: 'properties.standard', op: 'EQUAL' as const, values: [true] }
    : {
        op: 'OR' as const,
        values: [
          { field: 'properties.standard', op: 'EQUAL' as const, values: [false] },
          { field: 'properties.standard', op: 'MISSING' as const },
        ],
      };

export const isTemplateComponent: Filter = {
  field: 'properties_type',
  op: 'IN' as const,
  values: [InterfaceType.TemplateComponent],
};

/**
 * Template picker should list only templates that have been published (deployed) at least once.
 */
export const hasPublishedDeployment: Filter = {
  field: 'deploymentState',
  op: 'EXISTS' as const,
};

// server-side platform filter: templates are tagged with the applicationType of
// the interface they belong to; we match the parent page's platform so WEB pages
// don't see MOBILE-only templates and vice versa.
// field is `properties_manifest_type` on the Interface entity (holds
// WEB/MOBILE/COPILOT/DISPLAY) — see apps/platform/.../InterfaceManager/block.ts.
export const matchesApplicationType = (applicationType: ApplicationType): Filter => ({
  field: 'properties_manifest_type',
  op: 'IN' as const,
  values: [applicationType],
});
